import NoGlobalSearch from "Assets/Icons/NoGlobalSearch";
import SearchCrossIcon from "Assets/Icons/SearchCrossIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { mapToArrayForSelect } from "utilFunctions/helperFunctions/HelperFunction";
import "../PerformanceSearchBar.css";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import SearchFilterListing from "utilFunctions/shared/GlobalSearchBar/SearchFilterListing";
import {
  GlobalSearchFilterListing,
  GlobalSearchFilterListingWithOutFaculty,
} from "utilFunctions/Constants/Constants";
import "./index.css";
import GlobalSearchIcon from "Assets/Icons/GlobalSearchIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import ArrowUpRight from "Assets/Icons/ArrowUpRightIcon";
import { UserRoles as UR } from "utilFunctions/Constants/UserRoles";
import { UserInfoContext } from "Context/CommonContext";

const phrasesDesk = [
  "Search student and faculty",
  "Search student performance",
  "Search by student psid",
  "Search by student name",
  "Search by faculty name",
  "Search student and faculty",
];
const phrasesMob = [
  "Search",
  "Student performance",
  "Student psid",
  "Student name",
  "Faculty name",
  "Search",
];
const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

const SearchBar = (props: any) => {
  const { screen }: any = useWindowSize();
  const { selectedItem, setselectedItem, onRequestClose, input, setInput } =
    props;
  const { saveGlobalSearchData } = useGlobalSearchContext();
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const userInfo = useContext<any>(UserInfoContext);
  const [suggestdata] = useState([]);
  const [tags, setTags] = useState<any[]>([]);
  const ref = useRef(true);
  const currentRunId = useRef<number>(0);
  const inputRef = useRef<HTMLInputElement>(null);
  const inputSearchRef = useRef<HTMLInputElement>(null);
  const handleFocus = () => {
    setIsFocused(true);
  };

  // const handleBlur = () => {
  //   setIsFocused(false);
  // };
  useEffect(() => {
    if (inputSearchRef.current) {
      // inputSearchRef.current.focus();
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        setIsFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleChange = (e: any) => {
    const { value } = e.target;
    if (value != "") {
      const specialCharacterRegex = /^[A-Za-z0-9 ]+$/;
      // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const isValid = specialCharacterRegex.test(value);
      if (
        props.mode != "faculty_search" &&
        (!isValid || value.trim().length === 0 || parseInt(value) < 0)
      ) {
        props.setIsLoader && props.setIsLoader(false);
        return;
      }
      setInput(value);
      props.setIsLoader && props.setIsLoader(true);
      props.setInputValue && props.setInputValue(value);
      handleSuggestion();
    } else {
      props.setIsLoader && props.setIsLoader(false);
      setInput(value);
      props.setInputValue && props.setInputValue(value);
      handleSuggestion();
    }
  };
  const handleSuggestion = () => {
    const suggestFilterInput = suggestdata.filter((suggest: any) =>
      suggest.email !== null
        ? suggest.email.toLowerCase().includes(input.toLowerCase())
        : null
    );

    const suggestFilterTags = suggestFilterInput.filter(
      (suggest: any) => !tags.includes(suggest.email)
    );
    props.setSuggestions(suggestFilterTags);
  };
  const debouncedSearchTerm = useDebounce(input, 500);
  useEffect(() => {
    if (debouncedSearchTerm) {
      if (debouncedSearchTerm != props.searchName) {
        props.searchData(debouncedSearchTerm);
      }
    }
  }, [debouncedSearchTerm, props.selectedCategory]);
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const AddTags = (suggest: any) => {
    setTags([suggest.email]);
    props.setTagsList && props.setTagsList([suggest.email]);
    props.setTagsListId && props.setTagsListId([suggest.id]);
    setInput(suggest.name);
    props.setSearchName && props.setSearchName(suggest.name);
    const objforMapToSelect = {
      suggest: suggest,
      keyToSet: "acadToClassMap",
      order: false,
    };
    const newClassArraySelect = mapToArrayForSelect(objforMapToSelect);
    saveGlobalSearchData({
      pathurl: null,
      isBranchHealth: false,
      isStudentHealth: false,
      isPerformance: false,
    });
    const newSuggest = {
      ...suggest,
      acadToClassMap: newClassArraySelect,
      selectedYear: { label: suggest.academicYear, value: suggest.clazz },
    };
    RouteToModule(selectedItem, newSuggest);
    setInput("");
    onRequestClose && onRequestClose();
    props.setSuggestions([]);
  };
  const RouteToModule = (selectedItem: any, newSuggest: any) => {
    if (selectedItem.value == "student") {
      navigate("/admin/performance/" + newSuggest.psid, {
        replace: true,
        state: {
          selectedStudent: newSuggest,
        },
      });
    } else if (selectedItem.value === "faculty") {
      navigate("/admin/faculties/" + newSuggest.id, {
        replace: true,
        state: {
          selectedStudent: newSuggest,
        },
      });
    }
  };

  const handleSelectedUser = (suggestedUser: any) => {
    props.onClickHandler(suggestedUser);
    setInput(suggestedUser?.email);
    props.setSearchName && props.setSearchName(suggestedUser.email);
    props.setSuggestions([]);
  };
  const data = React.useMemo(() => props.suggestions, [props.suggestions]);
  // Add something to given element placeholder
  function addToPlaceholder(toAdd: any) {
    const inputElement = document.getElementById(
      "GlobalInputAutoSearch"
    ) as HTMLInputElement | null;
    if (inputElement) {
      inputElement.placeholder = inputElement.placeholder + toAdd;
    }

    // if (el) {
    //   el.attributes("placeholder", el.attributes("placeholder") + toAdd);
    // }

    //el.attributes("placeholder", el.attributes("placeholder") + toAdd);
    // Delay between symbols "typing"
    return new Promise((resolve) => setTimeout(resolve, 100));
  }

  // Cleare placeholder attribute in given element
  function clearPlaceholder() {
    const inputElement = document.getElementById(
      "GlobalInputAutoSearch"
    ) as HTMLInputElement | null;
    if (inputElement) {
      inputElement.placeholder = "";
    }
  }

  // Print one phrase
  function printPhrase(phrase: any, runId: number) {
    return new Promise((resolve) => {
      if (runId !== currentRunId.current) return resolve(false);
      // Clear placeholder before typing next phrase
      clearPlaceholder();
      const letters = phrase.split("");
      // For each letter in phrase
      letters.reduce(
        (promise: any, letter: any, index: any) =>
          promise.then(() => {
            if (runId !== currentRunId.current) return;
            // Resolve promise when all letters are typed
            if (index === letters.length - 1) {
              // Delay before start next phrase "typing"
              setTimeout(resolve, 1000);
            }
            return addToPlaceholder(letter);
          }),
        Promise.resolve()
      );
    });
  }

  // Print given phrases to element
  function printPhrases(phrases: any, focus: any, runId: number) {
    // For each phrase
    // wait for phrase to be typed
    // before start typing next
    if (focus) {
      phrases.reduce(
        (promise: any, phrase: any) =>
          promise.then(() => {
            // if (index === phrases.length - 1) {
            //   // Delay before start next phrase "typing"

            //   printPhrases(phrases, focus);
            // }
            if (runId !== currentRunId.current) return;
            return printPhrase(phrase, runId);
          }),
        Promise.resolve()
      );
    }
  }

  const run = React.useCallback((phrases: any, an: any) => {
    // do something!
    console.log(an, "isFocused");
    currentRunId.current += 1;
    printPhrases(phrases, an, currentRunId.current);
  }, []);
  // Start typing

  useEffect(() => {
    console.log(isFocused, "isFocused");
    if (isFocused) {
      ref.current = false;
      run(phrasesDesk, isFocused);
    } else {
      run(phrasesMob, isFocused);
      document
        .getElementById("GlobalInputAutoSearch")
        ?.setAttribute("placeholder", "Search student and faculty");
    }
    return () => {
      currentRunId.current += 1;
      document
        .getElementById("GlobalInputAutoSearch")
        ?.setAttribute("placeholder", "Search student and faculty");
    };
  }, [isFocused]);

  console.log("search Render", windowDimensions);

  return (
    <div ref={inputRef} className="w-100">
      <div
        className={
          ["xs", "sm", "md"].includes(screen)
            ? `GlobalSearchDivMB${isFocused ? " focused" : ""}`
            : `GlobalSearchDiv${isFocused ? " focused" : ""}`
        }
      >
        <input
          id="GlobalInputAutoSearch"
          className="GlobalInputAutoSearch"
          disabled={false}
          type={props.mode == "faculty_search" ? "email" : "text"}
          value={input}
          onChange={handleChange}
          onFocus={handleFocus}
          ref={inputSearchRef}
        />
        <div className="searchAndCloseIconDiv">
          {props.isLoader ? (
            <Spinner color="info" size="sm"></Spinner>
          ) : (
            <>
              {input && Boolean(props.suggestions.length) ? (
                <SearchCrossIcon
                  className="cursorHoverCSS"
                  onClick={() => {
                    props.setSuggestions([]);
                    props.setSearchName(null);
                    setInput("");
                  }}
                />
              ) : (
                <GlobalSearchIcon
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
      {input != "" ? (
        <div
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "searchFilterListingDivMB"
              : `searchFilterListingDiv${isFocused ? " focused" : ""}`
          }
        >
          <SearchFilterListing
            data={
              [
                UR.academicHead,
                UR.regionalHead,
                UR.nationalHead,
                UR.NADTeam,
                UR.branchEDP,
              ].includes(userInfo.fexRole)
                ? GlobalSearchFilterListing
                : GlobalSearchFilterListingWithOutFaculty
            }
            selectedItem={selectedItem}
            onSelectHandler={(name: string) => {
              setselectedItem(name);
            }}
            selectColor={"#008dc4"}
            unselectedColor={"#FFFFFF"}
            unselectedTextColor={"#757575"}
          ></SearchFilterListing>
        </div>
      ) : null}
      {input &&
      props.suggestions &&
      Array.isArray(props.suggestions) &&
      props.suggestions.length > 0 ? (
        <div
          className={
            ["xs", "sm", "md"].includes(screen)
              ? `global-tags-suggestions-mb${isFocused ? " focused" : ""}`
              : `global-tags-suggestions${isFocused ? " focused" : ""}`
          }
        >
          <InfiniteScroll
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "searchbarListingInfiniteScrollMB"
                : "searchbarListingInfiniteScroll"
            }
            dataLength={data.length}
            next={props.nextHandler}
            hasMore={props.hasMore}
            height={"auto"}
            loader={
              <div className="mx-auto text-center py-5 my-5">
                {<Spinner color="info"></Spinner>}
              </div>
            }
          >
            {props.suggestions.map((suggest: any, index: any) => (
              <div
                key={index}
                className="suggestion-item"
                onClick={() =>
                  ["faculty_search", "branchHealth"].includes(props.mode)
                    ? handleSelectedUser(suggest)
                    : AddTags(suggest)
                }
              >
                <div className="d-flex justify-content-between">
                  <Typography variant="body3" color="black">
                    {suggest.name}
                    {suggest.psid
                      ? ", PSID:" + suggest.psid
                      : `, Employee Id: + ${
                          suggest.employeeId && suggest.employeeId !== null
                            ? suggest.employeeId
                            : " "
                        }`}
                  </Typography>
                  <ArrowUpRight className="cursor-pointer"></ArrowUpRight>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        </div>
      ) : (
        input != "" &&
        !props.isLoader &&
        props.searchName != input && (
          <div
            className={
              ["xs", "sm", "md"].includes(screen)
                ? "noResultFoundGlobalSearchMB"
                : `noResultFoundGlobalSearch${isFocused ? " focused" : ""}`
            }
            style={{ flexDirection: "column" }}
          >
            <div>
              <NoResultFoundSearch
                divClassName={"noDataFoundGlobal"}
                primaryMessage="😔 No data found"
              >
                <NoGlobalSearch></NoGlobalSearch>
              </NoResultFoundSearch>
            </div>
          </div>
        )
      )}
    </div>
  );
};
function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (value === "") {
      setDebouncedValue("");
      return;
    }
    if (value.length >= 3) {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, delay]);
  return debouncedValue;
}
export default SearchBar;
